/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import NaviLeft from './NaviLeft';
import { BrowserRouter } from 'react-router-dom';
import RouterContainer from './RouterContainer';
import store from './stores/Store';
import Home from '../pages/Home/Home';
import HomeOAuth from '../pages/Home/HomeOAuth';
import { loginType } from "../config/ips";

const styles = {
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'center',
  },
  rightContent: {
    backgroundColor: '#FaF',
    height: '100%',
  }
};

class MainInner extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() { }
  componentWillUnmount() { }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        {(store.user.logined)
          && (store.user.uuid)
          &&
          (
            <BrowserRouter>
              <Grid container spacing={3}>
                <Grid item xs={2} sm={2}>
                  <NaviLeft />
                </Grid>
                <Grid item xs={10} sm={10}>
                  <RouterContainer />
                </Grid>
              </Grid>
            </BrowserRouter>
          )
        }
        {!(store.user.logined) &&
          (
            <>
              {loginType === 'password' && <Home />}
              {loginType === 'oauth2'   && <HomeOAuth />}
            </>
          )
        }
      </div>
    );
  }
}

const Main = observer(MainInner);

Main.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Main);